import {
    addSortToUrl,
    processFilters,
    processGetManyByReferenceFilter,
    processGetManyFilter,
    restoreEntityString,
    cleanEntityString,
    createUploadFormData,
    removeUrlFromUri,
    addUrlToUri, readJsonOrRefuse, refuseOnHttpError} from "./provider/defaults";
import {
    CreateParams,
    CreateResult,
    DataProvider,
    DeleteManyParams,
    DeleteParams,
    DeleteResult,
    GetListParams,
    GetListResult,
    GetManyParams,
    GetManyReferenceParams,
    GetManyReferenceResult,
    GetManyResult,
    GetOneParams,
    GetOneResult,
    UpdateManyParams,
    UpdateManyResult,
    UpdateParams,
    UpdateResult
} from "react-admin";
import {read_cookie} from 'sfcookies';
import {apiUrl, hostUrl, UseUrlManagerCleanUrl} from "../components/utils/url-manager";
import { MysteryShopper } from "../types/entities";


function cleanParams(data: any[]) : MysteryShopper {
    // console.log(data);
    return {
        id: data['id'],
        name: data['name'],
        status: data['status'],
        type: data['type'],
        msCode: data['msCode'],
        adminUser: cleanEntityString( data['adminUser'], '/hq_api/admin_users/'),
        customerAccount: cleanEntityString( data['customerAccount'], '/hq_api/customer_accounts/'),
        customerTargets: removeUrlFromUri(data['customerTargets'], '/hq_api/employees/'),
        adminTargets: data['adminTargets'],
        scheduledAt: data['scheduledAt'],
        updatedAt: data['updatedAt'],
        createdAt: data['createdAt'],
        fromNok: cleanEntityString(data['fromNok'], '/hq_api/noks/'),
        fromChoice: data['fromChoice'],
        fromPersona: cleanEntityString(data['fromPersona'], '/hq_api/nok_personas/' ),
        nokChoice: data['nokChoice'],
        scheduleType: data['scheduleType'],
        endDate: data['endDate'],
        startDate: data['startDate'],
        channel: data['channel'],
        formTo: data['formTo'],
        formUrl: data['formUrl'],
        company: cleanEntityString( data['company'], '/hq_api/companies/'),
        mysteryShopperResults: removeUrlFromUri(data['mysteryShopperResults'], '/hq_api/mystery_shopper_results/'),
    }
}

const mysteryShopperDataProvider: DataProvider = {

    getList: async (resource: string, params: GetListParams) : Promise<GetListResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processFilters(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any): { data: MysteryShopper[], total: number } => {
                let responseData: { data: MysteryShopper[], total: number } = {
                    data: [],
                    total: 0
                };
                if (Array.isArray(data['hydra:member'])) {
                    let Operator: any = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < Operator.length; i++) {
                        let operator: any = Operator[i];
                        responseData.data.push(cleanParams(operator))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error): Promise<GetListResult> => {
                console.log(error);
                return Promise.reject(error)
            });
        //return Promise.reject();
    },
    // get a single record by id
    getOne: async (resource: string, params: GetOneParams) : Promise<GetOneResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any): { data: MysteryShopper } => {
                let responseData: { data: MysteryShopper|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data);
                }
                return responseData;
            })
            .catch( (error: Error): Promise<GetOneResult> => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get a list of records based on an array of ids
    getMany: async (resource: string, params: GetManyParams): Promise<GetManyResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        url = processGetManyFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any): { data: MysteryShopper[], total: number } => {
                let responseData: { data: MysteryShopper[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let operators: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < operators.length; i++) {
                        let operator: any[] = operators[i];
                        responseData.data.push(cleanParams(operator));
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error): Promise<GetManyResult> => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // get the records referenced to another record, e.g. comments for a post
    getManyReference: async (resource: string, params: GetManyReferenceParams) : Promise<GetManyReferenceResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processGetManyByReferenceFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any): { data: MysteryShopper[], total: number } => {
                let responseData: { data: MysteryShopper[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let operators: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < operators.length; i++) {
                        let operator: any[] = operators[i];
                        responseData.data.push(cleanParams(operator));
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error): Promise<GetManyReferenceResult> => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // create a record
    create: async (resource: string, params: CreateParams) : Promise<CreateResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        url = UseUrlManagerCleanUrl({ url: url });

        const today = new Date();
        let hours: any = today.getHours();
        if (hours < 10) {
            hours = '0' + hours;
        }
        let minutes: any = today.getMinutes();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        let seconds: any = today.getSeconds();
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        const todayString: string = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' +
            hours + ':' + minutes + ':' + seconds;
        params.data.createAt = todayString;
        params.data.updateAd = todayString;
        params.data.adminUser = restoreEntityString(params.data.adminUser, '/hq_api/admin_users/');
        params.data.customerAccount = restoreEntityString(params.data.customerAccount, '/hq_api/customer_accounts/');
        params.data.customerTargets = addUrlToUri(params.data.customerTargets, '/hq_api/employees/');
        if (params.data.nokChoice === 'nok') {
            params.data.fromNok = restoreEntityString(params.data.fromNok, '/hq_api/noks/');
        }
        if (params.data.fromChoice === 'persona') {
            params.data.fromPersona = restoreEntityString(params.data.fromPersona, '/hq_api/nok_personas/');
        }

        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any): { data: MysteryShopper|null } => {
                let responseData: { data: MysteryShopper|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data);
                }
                return responseData;
            })
            .catch( (error: Error): Promise<CreateResult> => {
                console.log(error);
                return Promise.reject(error);
            });

    },
    // update a record based on a patch
    update: async (resource: string, params: UpdateParams) : Promise<UpdateResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.data.id;
        url = UseUrlManagerCleanUrl({ url: url });

        const today = new Date();
        let hours: any = today.getHours();
        if (hours < 10) {
            hours = '0' + hours;
        }
        let minutes: any = today.getMinutes();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        let seconds: any = today.getSeconds();
        if (seconds < 10) {
            seconds = '0' + seconds;
        }

        params.data.updatedAt = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' +
            hours + ':' + minutes + ':' + seconds;
        params.data.adminUser = restoreEntityString(params.data.adminUser, '/hq_api/admin_users/');
        params.data.customerAccount = restoreEntityString(params.data.customerAccount, '/hq_api/customer_accounts/');
        params.data.customerTargets = addUrlToUri(params.data.customerTargets, '/hq_api/employees/');
        if (params.data.nokChoice === 'nok') {
            params.data.fromNok = restoreEntityString(params.data.fromNok, '/hq_api/noks/');
        }
        if (params.data.fromChoice === 'persona') {
            params.data.fromPersona = restoreEntityString(params.data.fromPersona, '/hq_api/nok_personas/');
        }

        const request: Request = new Request(url, {
            method: 'PATCH',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/merge-patch+json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any): { data: MysteryShopper|null } => {
                let responseData: { data: MysteryShopper|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data);
                }
                return responseData;
            })
            .catch( (error: Error): Promise<UpdateResult> => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // update a list of records based on an array of ids and a common patch
    updateMany: async (resource: string, params: UpdateManyParams) : Promise<UpdateManyResult> => {
        return Promise.reject();
    },
    // delete a record by id
    delete: async (resource: string, params: DeleteParams) : Promise<DeleteResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<{ data: any }> => {
                return refuseOnHttpError(response)
                    .then((): { data: any } => ({ data: params }));
            })
            .catch( (error: Error): Promise<DeleteResult> => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // delete a list of records based on an array of ids
    deleteMany: async (resource: string, params: DeleteManyParams) : Promise<any> => {
        return Promise.reject();
    },
    getProfileData: (params: any): Promise<void> => {
        return Promise.resolve();
    }
}

export default mysteryShopperDataProvider;